import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadActivityService {


  url = environment.serverAPI9 + "/api/leadActivity";

  url1 = environment.serverAPI9 + "/api/makeCall";

  url3 = environment.serverAPI9 + "/api";

  url2 = environment.serverAPI9 + "/api/smartView";

  url4 = environment.serverAPI9 + "/api/lead";

  constructor(private http: HttpClient) { }

  getAllLeadActivity(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllLeadActivityDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getLeadActivityById(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/${leadId}`);
  }

  addOrEditLeadActivity(leadActivity: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, leadActivity);
  }

  LeadActivitySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllLeadActivityByLeadId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/New/lead/${leadId}`);
  }
  deleteByLeadActivityId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }


  makeCall(leadId: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}`, leadId);
  }

  makeDooctiClickToCall(lead): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall`, lead);
  }

  makeTelecmi(lead): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/telecmi`, lead);
  }

  callForBuzzDieal(lead): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/buzzdial`, lead);
  }

  calltoElevenlabs(lead): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/elevenlabs`, lead);
  }

  clickToCallAcefone(acefone): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/click/tocall/acefone`, acefone);
  }

  getBrandDataByMonthAndYear(brand: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/details/month`, brand);
  }

  searchActivityFilter(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,
      "additionalQuery": additionalQuery

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition/advanced${queryParams}`, requestBody);
  }


  searchLeadAdvanceFilter(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,
      "additionalQuery": additionalQuery

    };


    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url4}/advanced/filter${queryParams}`, requestBody);
  }


  searchLeadAdvanceFilterNew(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url4}/advanced/filter/new${queryParams}`, additionalQuery);
  }

  searchAllActivity(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/filter/advanced${queryParams}`, requestBody);
  }


  getAllLeadActivityByPageable(Page: any, size: any, sort: any, leadId: any, taskType: any): Observable<Object> {
    return this.http.get(`${this.url}/New/lead/taskType/${leadId}/${taskType}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllLeadActivityByPageableNew(Page: any, size: any, sort: any, leadId: any, taskType: any): Observable<Object> {
    return this.http.get(`${this.url}/New/lead/taskType/new/${leadId}/${taskType}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllDealActivityByPageable(Page: any, size: any, sort: any, leadId: any, taskType: any): Observable<Object> {
    return this.http.get(`${this.url}/New/deal/taskType/${leadId}/${taskType}?page=${Page}&size=${size}&sort=${sort}`);
  }

  sendWebToMobileCall(lead: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/trigerCall`, lead);
  }

  generateAiForActivity(id: any): Observable<any> {
    return this.http.post(`${this.url}/${id}/generate`, {});
  }
}

